<template>
  <iColumn gap="small">
    <template v-if="payForReferrals">
      <iText>
        Share your personalized tracking link with your audience to earn commissions.
      </iText>
      <iText v-if="hasMonthlyPlan">
        earn $10 for each subscriber who purchases the monthly plan
      </iText>
      <iText v-if="hasYearlyPlan">
        earn $12 for each subscriber who purchases the yearly plan
      </iText>
      <iCopyText
        :width="240"
        :text="referralLink"
        copy-message="Link Copied!"
        message-position="right"
      />
    </template>
    <iText v-else variant="subtle">
      This publication is not paying for referrals at this time.
    </iText>
  </iColumn>
</template>

<script>
import { mapState } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "PublicationReferralLink",
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "publication",
      "activeSubscriptionPlans",
    ]),
    ...mapState(useGeneralStore, ["orgId"]),
    payForReferrals() {
      return this.publication.pay_for_referrals === 1;
    },
    hasMonthlyPlan() {
      return (this.activeSubscriptionPlans || []).some(
        plan => plan.billing_frequency === "monthly",
      );
    },
    hasYearlyPlan() {
      return (this.activeSubscriptionPlans || []).some(
        plan => plan.billing_frequency === "annually" ||
          plan.billing_frequency === "yearly",
      );
    },
    referralLink() {
      const publicationId = this.publication.publication_id;
      return `https://inspiration.app/destination/${this.publication.org_id}/${publicationId}/refer/${this.orgId}`;
    },
  },
};
</script>

<style scoped></style>
